import { render } from "./IconRampLeft.vue?vue&type=template&id=38922a4f"
import script from "./IconRampLeft.vue?vue&type=script&lang=js"
export * from "./IconRampLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__